// components/ui/table/TableBody.jsx
export const TableBody = ({ children, className = "" }) => {
  return (
    <tbody className={`[&_tr:last-child]:border-0 ${className}`}>
      {children}
    </tbody>
  );
};
